module.exports = __webpack_public_path__ + "static/Logo-CompaszOOm-7b8fec325bb257d239bdf038d7bc1b80.png";